import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { UiModule } from "@webapp/ui/ui.module";
import { SharedModule } from "@webapp/shared/shared.module";
import { relatedItemsDeclarations } from "./components/related-items";

@NgModule({
  imports: [UiModule, SharedModule, FormsModule],
  declarations: [...relatedItemsDeclarations],
  providers: [],
})
export class LinksModule {}
